import mixins from 'vue-typed-mixins';
import dayjs from 'dayjs';

import ElDatePickerMixin from '@/mixins/ElDatePickerMixin';

import { DAYJS_YM_NUMBER_FORMAT } from '@/classes/common/Constants';

// el-date-picker type=monthをyyyyMM形式のnumber型でやり取りできるようにしたコンポーネント
export default mixins(ElDatePickerMixin).extend({
  name: 'ElwYmPicker',

  props: {
    value: {
      type: Number,
      default: null,
    },
    autoDefaultValue: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    name: {
      type: String,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    ym: {
      get(): string | null {
        return this.value !== null ? String(this.value) : null;
      },
      set(v: string): void {
        this.$emit('update:value', v !== null ? Number(v) : null);
      },
    },
  },

  created(): void {
    if (this.autoDefaultValue) {
      const ym = dayjs().format(DAYJS_YM_NUMBER_FORMAT);
      this.$emit('update:value', Number(ym));
    }
  },
});
